module.exports = __webpack_public_path__ + "static/media/monitor-bottom.ff95008d.png";